export const USERNAME = "projectH@gmail.com";
export const PASS = "projectHPassword";
export const SESSION_KEY = "ai-omatic-user-session";
export const API_URL = "https://project-h-api.onrender.com";
